export default "__VITE_ASSET__CbCm2y$n__"